/* eslint-disable operator-linebreak */
import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Col, Container, Row } from 'react-bootstrap';
import Select from 'react-select';
import LoginBgOne from './LoginBgOne';
import ContentBlock from '../../Components/contentBlock/ContentBlock';
import { SimpleButton } from '../../Components/button';
// import CustomSelect2 from '../../Components/customSelect2/CustomSelect2';
import i18n from '../../i18n';

const network = [
  { value: '1', label: 'Ufone' },
  { value: '2', label: 'Jazz' },
  { value: '3', label: 'Telenor' },
  { value: '4', label: 'Zong' }
];

function LoginWithPhone() {
  const [selectValue, SetSelectValue] = useState();
  const {
    control,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      number: '',
      select: {}
    }
  });
  const onSubmit = (data) => console.log(data);
  // const onErrors = (errors) => console.error(errors);

  console.log(selectValue);

  const selectedOption = () => {
    
  }

  return (
    <LoginBgOne>
      <div className="loginWithPhone">
        <Container>
          <Row>
            <Col md={6} />
            <Col md={6}>
              <div className="content">
                <Row>
                  <Col md={12}>
                    <ContentBlock
                      heading={i18n.t('whats_phone_number')}
                      body={i18n.t('need_check_account_first')}
                    />
                    <form className="form" onSubmit={handleSubmit(onSubmit)}>
                      <label htmlFor="number" className="inputLabel">
                        {i18n.t('phone_number')}*
                      </label>
                      <div className="phone_detail">
                        <div>
                          <div className="input_box">
                            <span>+92 </span>
                            <input
                              placeholder=""
                              className="custom_input"
                              type="text"
                              name="number"
                              {...register('number', {
                                required: true,
                                maxLength: 9
                              })}
                            />
                          </div>
                          {errors.number && <span>This field is required</span>}
                        </div>
                        <div>
                          <Controller
                            name="select"
                            onChnage={(e) => SetSelectValue(e.targt.value)}
                            control={control}
                            value={selectedOption}
                            render={({ field }) => (
                              <Select {...field} options={network} />
                            )}
                          />
                          {errors.network && (
                            <span>This field is required</span>
                          )}
                        </div>
                      </div>
                      <div className="btns_container">
                        {/* <SimpleAncer to="/signup" text="continue" /> */}
                        <SimpleButton type="submit" text={i18n.t('continue')} />
                      </div>
                    </form>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </LoginBgOne>
  );
}

export default LoginWithPhone;
